import React from 'react'
import './RCI.css';
import { useTranslation } from 'react-i18next';
import VideoLower from './Elements/VideoLower';
import Cardbbss from './Elements/Cardbbss';
import Cardeec from './Elements/Cardeec';
import i18n from 'i18next';

const RCI = () => {
    var lang = i18n.language;
  const { t } = useTranslation();

  document.title = t("page-title.rci");

  return (
    <div className="UIRci">
      <div className="container-fluid background">
        <div className="bg-image">
        <VideoLower/>
        </div>
        <div className="container">
          <div className="heading">
            <h2>{t('storage.ngen-products')}</h2>
            <h1>{t('pages.rci')}</h1>
          </div>
        </div>
      </div>
      <div className="container hero-image">
      <img src={`${process.env.PUBLIC_URL + '/images/' + lang + "/rci-header-image.png"}`} alt="" className='starter-whatwedo' />
      </div>
      <div className="overlay">
        <img src={`${process.env.PUBLIC_URL}/images/w-overlay-tl.svg`} alt="" />
      </div>
      <div className="container content">
        <div className="text">
          <p>{t('rci.text-1')}</p>
        </div>
      </div>
      <div className="container-fluid main">
      <div className="container cards">
        <div className="heading">
          <h4>{t('storage.other-products')}</h4>
          <h3>{t('storage.you-might-also-like')}</h3>
        </div>
        <div className="row cards">
        <div className="col-sm-12 col-md-6 col-lg-4">
            <Cardbbss/>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4">
            <Cardeec/>
          </div>
        </div>
      </div>
      </div>
    </div >
  )
}
export default RCI